exports.isLoggedIn = () => {
    if (window.sessionStorage.isLogged) {
        return true
    } else {
        return false
    }
}


